import { PropsWithChildren } from "react";

export interface RenderAssets {
  styles?: string[] | undefined;
  modules?: string[] | undefined;
  preloadedModules?: string[] | undefined;
}

export interface HtmlPageProps extends PropsWithChildren {
  assets?: RenderAssets | undefined;
  error?: string | undefined;
}

export default function HtmlPage({ assets, children, error }: HtmlPageProps) {
  return (
    <html lang="en">
      <head>
        {assets?.styles?.map((style, index) => (
          <link rel="stylesheet" href={style} key={index} />
        ))}
        {assets?.modules?.map((module, index) => (
          <script type="module" src={module} key={index} />
        ))}
        {assets?.preloadedModules?.map((module, index) => (
          <link rel="modulepreload" href={module} key={index} />
        ))}
        {error && <meta name="x-aqora-error" content={error} />}
        <script async src="/include-cookies.js"></script>
      </head>
      <body>
        <div id="root">{children}</div>
      </body>
    </html>
  );
}
